<template>
  <div class="page-class page-user-list">
    <h1 class="page-title text-center">{{ title }}</h1>
    <b-row class="mb-3">
      <b-col md="6" sm="12" class="mb-2">
        <b-card class="box-shadow2 h-100" :class="{ 'bg-dark text-light border-secondary': isDarkMode }">
          <h6 class="mb-2">Total Queries</h6>
          <h3 class="mb-0">{{ pagination.total_rows }}</h3>
        </b-card>
      </b-col>
      <b-col md="6" sm="12" class="mb-2">
        <b-card class="box-shadow2 h-100" :class="{ 'bg-dark text-light border-secondary': isDarkMode }">
          <h6 class="mb-2">Last Query Submitted Date</h6>
          <h3 class="mb-0">{{ lastUploadedDate }}</h3>
        </b-card>
      </b-col>
    </b-row>
    <silver-coin-box
      :columns="columns"
      :rows="filteredRows"
      :baseUrl="listBaseUrl"
      :loading="loading"
      :searchItems="effectiveSearchItems"
      :filterOptions="filterOptions"
      :showSearch="true"
      :showFilter="true"
      :showToolbar="true"
      :showPagination="true"
      :showDownload="false"
      :pagination="pagination"
      :showList="false"
      listText="New query"
      emptyText="No queries found."
      @edit="onEdit"
      @delete="onDelete"
      @list="onNew"
    >
      <template #after-toolbar-actions>
        <b-row class="mb-2 mx-0">
          <b-col cols="12" class="px-0">
            <b-button
              v-if="!isQmsPayrollClosureRole"
              size="sm"
              class="box-shadow2 btn btn-success mb-2 mr-2"
              @click="onNew"
            >
              <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />New query
            </b-button>
            <b-button
              v-if="!isQmsOtpGuestSession"
              size="sm"
              class="box-shadow2 btn btn-success mb-2 mr-2"
              :disabled="downloadingReport"
              @click="onDownloadReport"
            >
              <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />Download report
              <span v-if="downloadingReport" class="spinner spinner-white ml-1"></span>
            </b-button>
            <!-- <b-button
              v-if="!isQmsOtpGuestSession && !isQmsPayrollClosureRole"
              size="sm"
              class="box-shadow2 btn btn-success mb-2 mr-2"
              :disabled="uploadedUsers || !rows.length"
              @click="onUploadedUsers"
            >
              <font-awesome-icon :icon="['fas', 'upload']" class="mr-1" />
              Upload Users
              <span v-if="uploadedUsers" class="spinner spinner-white"></span>
            </b-button>
            <b-button
              v-if="!isQmsOtpGuestSession && !isQmsPayrollClosureRole"
              size="sm"
              class="box-shadow2 btn btn-danger mb-2 mr-2"
              :disabled="deletingUploadedUsers || !rows.length"
              @click="onDeleteUploadedUsers"
            >
              <font-awesome-icon :icon="['fas', 'trash']" class="mr-1" />
              Delete Upload Users
              <span v-if="deletingUploadedUsers" class="spinner spinner-white"></span>
            </b-button> -->
          </b-col>
        </b-row>
      </template>
    </silver-coin-box>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import Vue from 'vue';
import SilverCoinBox from '../../components/SilverCoinBox.vue';
import qmsService from '../../services/qmsService';
import { normalizeQmsListQuery } from '../../helper/qmsListQuery';

export default {
  components: { SilverCoinBox },
  name: 'QmsList',
  metaInfo() {
    return {
      title: 'QMS'
    };
  },
  data() {
    return {
      title: this.$route.name === 'qms-admin' ? 'QMS Admin' : 'Query Management (QMS)',
      searchItems: ['Employee Mobile', 'Employee Code', 'Store Id', 'Employee Name', 'Department', 'Query Type'],
      filterOptions: [
        { value: null, text: 'Select Status' },
        { value: 'open', text: 'Open' },
        { value: 'closed', text: 'Closed' }
      ],
      uploadedUsers: false,
      deletingUploadedUsers: false,
      downloadingReport: false
    };
  },
  mounted() {
    const rawQuery = _.isEmpty(this.$route.query) ? {} : this.$route.query;
    if (this.isQmsOtpGuestSession && !rawQuery.mobile && typeof localStorage !== 'undefined') {
      const savedMobile = localStorage.getItem('qms-mobile-number');
      if (savedMobile) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...rawQuery,
            mobile: savedMobile
          }
        });
        return;
      }
    }
    this.fetchQmsList(rawQuery);
  },
  watch: {
    $route(to, from) {
      if (to.name === from.name && _.isEqual(to.query, from.query)) {
        return;
      }
      this.title = to.name === 'qms-admin' ? 'QMS Admin' : 'Query Management (QMS)';
      this.fetchQmsList(to.query, to.name);
    }
  },
  methods: {
    ...mapActions('qms', ['list', 'listByRole', 'listAdmin', 'deleteOne']),
    fetchQmsList(query = {}, routeName = this.$route.name) {
      let listAction = 'listByRole';
      if (this.isQmsOtpGuestSession) {
        listAction = 'list';
      } else if (routeName === 'qms-admin') {
        listAction = 'listAdmin';
      }
      this[listAction]({ query: this.buildListQuery(query, routeName), router: this.$router });
    },
    buildListQuery(query = {}) {
      const q = { ...(query || {}) };
      delete q.isQMSAdmin;
      delete q.isQMSAdmin;
      if (this.isQmsOtpGuestSession && !q.mobile && typeof localStorage !== 'undefined') {
        const savedMobile = localStorage.getItem('qms-mobile-number');
        if (savedMobile) {
          q.mobile = savedMobile;
        }
      }
      return q;
    },
    csvCell(value) {
      let normalized = value;
      if (Array.isArray(value)) {
        normalized = value
          .map(item => {
            if (typeof item === 'string') {
              return item;
            }
            return item && item.url ? item.url : '';
          })
          .filter(Boolean)
          .join(' | ');
      }
      return `"${String(normalized == null ? '' : normalized).replace(/"/g, '""')}"`;
    },
    async onDownloadReport() {
      if (this.isQmsOtpGuestSession || this.downloadingReport) {
        return;
      }

      this.downloadingReport = true;
      try {
        const query = normalizeQmsListQuery(this.buildListQuery(this.$route.query));
        query.page = 1;
        query.page_size = 99999;
        const listRequest = this.$route.name === 'qms-admin'
          ? qmsService.getQmsAdminList({ query })
          : qmsService.getQmsListByRole({ query });
        const response = await listRequest;
        const data = response || {};
        const reportRows = data.rows || (data.data && data.data.rows) || [];
        const columns = [
          ['Employee Code', 'employeeCode'],
          ['Store Id', 'storeCode'],
          ['Employee Name', 'employeeName'],
          ['Employee Mobile', 'employeeMobile'],
          ['Department', 'department'],
          ['Query Type', 'queryType'],
          ['Description', 'queryDescription'],
          ['Employee Attachments', 'employeeRefImages'],
          ['Resolution Comments', 'closureRemarks'],
          ['Role Attachments', 'closureRefImages'],
          ['Closed', 'isClosed'],
          ['Resolution/Closure Date', 'closedAt'],
          ['Closed By', 'closedByName'],
          ['Closed Level', 'closedByLevel'],
          ['TAT', 'tatTime'],
          ['Created', 'createdAt']
        ];
        const csvRows = [
          columns.map(([label]) => this.csvCell(label)).join(','),
          ...reportRows.map(row =>
            columns
              .map(([, key]) => {
                const snakeCaseKey = _.snakeCase(key);
                return this.csvCell(row[key] != null ? row[key] : row[snakeCaseKey]);
              })
              .join(',')
          )
        ];
        const blob = new Blob([`\ufeff${csvRows.join('\n')}`], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `qms-report-${moment().format('YYYY-MM-DD')}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (e) {
        this.$store.dispatch(
          'common/handleServiceException',
          { e, router: this.$router },
          { root: true }
        );
      } finally {
        this.downloadingReport = false;
      }
    },
    onNew() {
      this.$router.push('/qms/new');
    },
    onEdit({ row }) {
      this.$router.push(`/qms/${row.id}`);
    },
    onDelete({ row }) {
      Vue.swal({
        title: 'Delete this query?',
        text: 'This cannot be undone.',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        },
        preConfirm: () => {
          this.deleteOne({ id: row.id, router: this.$router });
        }
      });
    },
    onUploadedUsers() {
      const allowedExtensions = ['csv', 'xls', 'xlsx'];
      this.uploadedUsers = true;
      Vue.swal({
        title: 'Upload Users File',
        text: 'Choose a CSV or Excel file to upload users.',
        input: 'file',
        inputAttributes: {
          accept: '.csv,.xls,.xlsx'
        },
        showCancelButton: true,
        confirmButtonText: 'Attach File',
        cancelButtonText: 'Cancel',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        },
        preConfirm: file => {
          if (!file) {
            Vue.swal.showValidationMessage('Please choose a file.');
            return false;
          }

          const extension = (file.name.split('.').pop() || '').toLowerCase();
          if (!allowedExtensions.includes(extension)) {
            Vue.swal.showValidationMessage('Only CSV, XLS, and XLSX files are allowed.');
            return false;
          }

          return file;
        }
      })
        .then(result => {
          if (result && result.isConfirmed && result.value) {
            const selectedFile = result.value;
            this.$store.dispatch(
              'alert/success',
              {
                showType: 'toast',
                position: 'center',
                title: '',
                text: `File attached: ${selectedFile.name}`
              },
              { root: true }
            );
          }
        })
        .finally(() => {
          this.uploadedUsers = false;
        });
    },
    onDeleteUploadedUsers() {
      if (!this.rows.length) {
        return;
      }

      Vue.swal({
        title: 'Delete all uploaded users?',
        text: `This will delete ${this.rows.length} users from the current list.`,
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, delete all',
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        },
        preConfirm: async () => {
          this.deletingUploadedUsers = true;
          const deletePromises = this.rows.map(row => qmsService.deleteOne({ id: row.id }));
          const deleteResults = await Promise.allSettled(deletePromises);
          const failed = deleteResults.filter(result => result.status === 'rejected').length;
          this.deletingUploadedUsers = false;

          if (failed > 0) {
            throw new Error('Some users could not be deleted.');
          }

          await this.fetchQmsList(this.$route.query);
        }
      })
        .then(result => {
          if (result && result.isConfirmed) {
            this.$store.dispatch(
              'alert/success',
              { showType: 'toast', position: 'center', title: '', text: 'All uploaded users deleted successfully.' },
              { root: true }
            );
          }
        })
        .catch(() => {
          this.deletingUploadedUsers = false;
          this.$store.dispatch(
            'alert/error',
            { showType: 'toast', position: 'center', title: '', text: 'Unable to delete uploaded users.' },
            { root: true }
          );
        });
    }
  },
  computed: {
    ...mapState('qms', ['loading', 'pagination', 'rows']),
    ...mapState('darkMode', ['isDarkMode']),
    ...mapGetters('auth', ['isLoggedIn', 'isQmsPayrollClosureRole']),
    isQmsOtpGuestSession() {
      if (typeof sessionStorage === 'undefined') {
        return false;
      }
      return sessionStorage.getItem('qmsOtpVerified') === 'true' && !this.isLoggedIn();
    },
    listBaseUrl() {
      return this.$route.name === 'qms-admin' ? '/qms/admin' : '/qms';
    },
    columns() {
      const columns = [
        {
          type: 'row_num',
          headerText: '#',
          class: { 'text-center': true },
          textKey: 'rowNum',
          width: '3%'
        },
        {
          type: 'string',
          headerText: 'Employee Code',
          class: { 'text-center': true },
          textKey: 'employeeCode',
          width: this.isQmsOtpGuestSession ? '5%' : '4%'
        },
        {
          type: 'string',
          headerText: 'Store Id',
          class: { 'text-center': true },
          textKey: 'storeCode',
          width: this.isQmsOtpGuestSession ? '5%' : '4%'
        },
        {
          type: 'string',
          headerText: 'Employee Name',
          class: { 'text-center': true },
          textKey: 'employeeName',
          width: this.isQmsOtpGuestSession ? '6%' : '5%'
        },
        {
          type: 'string',
          headerText: 'Department',
          class: { 'text-center': true },
          textKey: 'department',
          width: this.isQmsOtpGuestSession ? '6%' : '5%'
        },
        {
          type: 'string',
          headerText: 'Query Type',
          class: { 'text-center': true },
          textKey: 'queryType',
          width: '11%'
        },
        {
          type: 'string',
          headerText: 'Description',
          class: { 'text-center': true },
          textKey: 'queryDescription',
          width: this.isQmsOtpGuestSession ? '10%' : '9%'
        },
        {
          type: 'attachments',
          headerText: 'Employee Attachments',
          class: { 'text-center': true },
          textKey: 'employeeRefImages',
          width: this.isQmsOtpGuestSession ? '7%' : '6%'
        },
        {
          type: 'string',
          headerText: 'Resolution Comments',
          class: { 'text-center': true },
          textKey: 'closureRemarks',
          width: this.isQmsOtpGuestSession ? '7%' : '8%'
        },
        {
          type: 'attachments',
          headerText: 'Role Attachments',
          class: { 'text-center': true },
          textKey: 'closureRefImages',
          width: this.isQmsOtpGuestSession ? '7%' : '6%'
        },
        {
          type: 'string',
          headerText: 'Query Resolution/Closer Date',
          class: { 'text-center': true },
          textKey: 'closedAt',
          width: '8%'
        },
        {
          type: 'string',
          headerText: 'Closed By',
          class: { 'text-center': true },
          textKey: 'closedByName',
          width: this.isQmsOtpGuestSession ? '6%' : '5%'
        },
        {
          type: 'string',
          headerText: 'Closed Level',
          class: { 'text-center': true },
          textKey: 'closedByLevel',
          width: this.isQmsOtpGuestSession ? '6%' : '5%'
        },
        {
          type: 'string',
          headerText: 'TAT',
          class: { 'text-center': true },
          textKey: 'tatTime',
          width: this.isQmsOtpGuestSession ? '5%' : '4%'
        },
        {
          type: 'string',
          headerText: 'Created',
          class: { 'text-center': true },
          textKey: 'createdAt',
          width: this.isQmsOtpGuestSession ? '8%' : '5%'
        }
      ];

      if (!this.isQmsOtpGuestSession) {
        columns.push({
          type: 'functions',
          headerText: 'Functions',
          class: { 'text-center': true },
          width: '12%',
          functions: {
            edit: true,
            delete: true
          }
        });
      }

      return columns;
    },
    filteredRows() {
      const selectedFilter = String(this.$route.query.filter || '').toLowerCase();
      if (selectedFilter !== 'open' && selectedFilter !== 'closed') {
        return this.rows;
      }
      return this.rows.filter(row => {
        const closedRaw = row.isClosed;
        const isClosed = closedRaw === true || closedRaw === 'true' || closedRaw === 1 || closedRaw === '1';
        return selectedFilter === 'closed' ? isClosed : !isClosed;
      });
    },
    effectiveSearchItems() {
      if (this.isQmsOtpGuestSession) {
        return ['Query Type'];
      }
      return this.searchItems;
    },
    lastUploadedDate() {
      if (!this.rows.length) {
        return 'N/A';
      }

      const parseCreatedAt = value => {
        if (!value) return null;
        const m = moment(value, ['DD-MM-YYYY HH:mm', moment.ISO_8601], true);
        return m.isValid() ? m : null;
      };

      const latestCreatedAt = this.rows.reduce((latestMoment, row) => {
        const rowMoment = parseCreatedAt(row.createdAt);
        if (!rowMoment) {
          return latestMoment;
        }
        if (!latestMoment || rowMoment.isAfter(latestMoment)) {
          return rowMoment;
        }
        return latestMoment;
      }, null);

      return latestCreatedAt ? latestCreatedAt.format('DD MMM YYYY, hh:mm A') : 'N/A';
    }
  }
};
</script>
